import { Error } from '../Error'
import { Width } from '../Width'

import { Label } from '@/components/ui/label'
import { Textarea as TextAreaComponent } from '@/components/ui/textarea'

import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type {
  FieldErrorsImpl,
  FieldValues,
  RegisterOptions,
  UseFormRegister,
} from 'react-hook-form'

type TextareaProps = TextField & {
  errors: Partial<FieldErrorsImpl>
  register: UseFormRegister<FieldValues>
  rows?: number
  placeholder?: string
  description?: string
  validation?: RegisterOptions<FieldValues>
}

export const Textarea: React.FC<TextareaProps> = ({
  name,
  defaultValue,
  errors,
  label,
  register,
  required,
  rows = 3,
  placeholder,
  description,
  validation,
}) => {
  const validationRules: RegisterOptions<FieldValues> = {
    required: required ? (required === true ? 'This field is required' : required) : false,
    maxLength: { value: 2000, message: 'Maximum length is 2000 characters' },
    ...validation,
  }

  return (
    <Width>
      <Label htmlFor={name}>
        {label}

        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      {description && <p className="mb-2 text-sm text-muted-foreground">{description}</p>}
      <TextAreaComponent
        defaultValue={defaultValue}
        id={name}
        rows={rows}
        {...register(name, validationRules)}
        placeholder={placeholder}
      />

      {errors[name] && <Error name={name} />}
    </Width>
  )
}
